(function () {
  'use strict';
  if (window.WPOOpenAIAds) return;
  var pixelId = 'XNHwHtExsVzeuErNqoEqDU';
  var intakeUrl = 'https://hook.us2.make.com/n9k38i1xfqmixl9pfk4scb84j88ov0ud';
  var initialized = false;
  var sent = new Set();
  var preview = !!(window.Shopify && (window.Shopify.designMode || (window.Shopify.theme && window.Shopify.theme.role !== 'main'))) || new URLSearchParams(window.location.search).has('preview_theme_id');
  function allowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !preview && !!p && p.marketingAllowed() === true && p.analyticsProcessingAllowed() === true;
    } catch (e) { return false; }
  }
  function syncConsent() {
    try {
      var consent = allowed();
      if (!initialized && consent) {
        if (!window.oaiq) {
          var q = function () { q.q.push(arguments); };
          q.q = [];
          window.oaiq = q;
          var script = document.createElement('script');
          script.async = true;
          script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
          document.head.appendChild(script);
        }
        window.oaiq('consent', consent);
        window.oaiq('init', { pixelId: pixelId, debug: false });
        initialized = true;
      } else if (initialized) {
        window.oaiq('consent', consent);
      }
    } catch (e) {}
  }
  function eligible(data) {
    if (!data || data.test === true || data.is_test === true) return false;
    var email = String(data.email || '').trim().toLowerCase();
    var notes = String(data.problem_description || '').trim();
    if (!data.first_name || !data.last_name || !data.vehicle_type || email.length < 6 || email.indexOf('@') < 1 || notes.length < 6) return false;
    if (/mailinator\.com|tempmail|10minutemail|@example\.(com|org|net)$/.test(email)) return false;
    if (/http:\/\/|https:\/\/|www\.|seo|backlink|guest post|casino|crypto/i.test(notes)) return false;
    return true;
  }
  function lead(data) {
    try {
      if (!allowed() || !eligible(data)) return;
      syncConsent();
      if (!initialized) return;
      var id = data.submission_id;
      if (!id || sent.has(id)) return;
      var key = 'wpo_oai_lead_' + id;
      try { if (window.sessionStorage.getItem(key)) return; } catch (e) {}
      window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: id });
      sent.add(id);
      try { window.sessionStorage.setItem(key, '1'); } catch (e) {}
    } catch (e) {}
  }
  window.WPOOpenAIAds = { version: 1 };
  var originalFetch = window.fetch;
  window.fetch = function (input, options) {
    var payload = null;
    var consentAtSubmission = false;
    try {
      if (typeof input === 'string' && input === intakeUrl && options && String(options.method).toUpperCase() === 'POST' && typeof options.body === 'string') {
        payload = JSON.parse(options.body);
        consentAtSubmission = allowed();
      }
    } catch (e) {}
    var request = originalFetch.apply(this, arguments);
    if (payload && consentAtSubmission) {
      request.then(function (response) {
        if (response.ok) lead(payload);
      }, function () {}).catch(function () {});
    }
    return request;
  };
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function' && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) syncConsent(); });
  } else { syncConsent(); }
})();
